export enum EContractsSortField {
  PROJECT = "project",
  CREATED_DATE = "created_date",
  STATUS = "status",
  TOTAL = "total",
  PERCENTUAL = "percentual",
}
